import type React from 'react';
import type { CSSProperties } from 'react';
import { useReducedMotion } from '../../hooks';
import styles from './pop-in.module.scss';

/** Seconds a pop-in takes from start to rest. */
export const POP_IN_DURATION = 0.5;

export interface PopInProps {
  /** Seconds to wait before popping in. */
  delay?: number;
  /** Seconds the pop-in takes. */
  duration?: number;
  /** When false, children render in their final state with no animation. */
  play?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * Pops its children in: scale 0.6 → 1.08 → 1 while fading in. Renders in the final state when `play`
 * is false or the user prefers reduced motion.
 */
export const PopIn: React.FC<PopInProps> = ({
  delay = 0,
  duration = POP_IN_DURATION,
  play = true,
  className,
  children,
}) => {
  const reducedMotion = useReducedMotion();
  const animate = play && !reducedMotion;

  return (
    <div
      className={[animate ? styles.popIn : null, className].filter(Boolean).join(' ') || undefined}
      style={animate ? ({ '--pop-delay': `${delay}s`, '--pop-duration': `${duration}s` } as CSSProperties) : undefined}
    >
      {children}
    </div>
  );
};
